import { render, staticRenderFns } from "./PageBuilderDividerWidget.vue?vue&type=template&id=334ebb42"
import script from "./PageBuilderDividerWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderDividerWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports